module.exports = __webpack_public_path__ + "img/tiaokong.98c7da46.png";